var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgVolumeOn16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m7.9 3.056-3.889 3.11H.902v4.667h3.11l3.89 3.112V3.055Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D5DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M12.958 4.379a5.83 5.83 0 0 1 0 8.242M10.9 6.437a2.914 2.914 0 0 1 0 4.12"
  })));
});
SvgVolumeOn16.displayName = "SvgVolumeOn16";
export default SvgVolumeOn16;